import ModalForm from '../../shared/components/modal-form';

export default class FlaggingForm extends ModalForm {
  constructor() {
    super(...arguments);

    this.$formFlaggableType = this.$element.find('.flagItem-flaggable-type');
    this.$formFlaggableId = this.$element.find('.flagItem-flaggable-id');

    this.$formMessageElement = this.$element.find('.flagItem-message');
    this.$formOptionElement = this.$element.find('.flagItem-option').first();

    this.bindEvents();
  }

  bindEvents() {
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalShown = this.handleModalShown.bind(this);
    this.handleModalHide = this.handleModalHide.bind(this);

    this.$element.on('show.bs.modal.FlaggingForm', this.handleModalShow);
    this.$element.on('shown.bs.modal.FlaggingForm', this.handleModalShown);
    this.$element.on('hide.bs.modal.FlaggingForm', this.handleModalHide);

    super.bindEvents(...arguments);
  }

  unbindEvents() {
    this.$element.off('show.bs.modal.FlaggingForm', this.handleModalShow);
    this.$element.off('shown.bs.modal.FlaggingForm', this.handleModalShown);
    this.$element.off('hide.bs.modal.FlaggingForm', this.handleModalHide);

    super.unbindEvents(...arguments);
  }

  handleModalShown() {
    this.$formMessageElement.focus();
  }

  handleModalShow() {
    this.$formMessageElement.val('');
    this.$formOptionElement.prop('checked', true);

    super.handleModalShow(...arguments);
  }

  handleModalHide() {
    if (this.formWasSuccessful) {
      window.Turbolinks.reload();
    }

    super.handleModalHide();
  }

  handleFormSuccess() {
    this.formWasSuccessful = true;
    this.$element.modal('hide');
  }

  setFlaggableType(type) {
    this.$formFlaggableType.val(type);
  }

  setFlaggableId(id) {
    this.$formFlaggableId.val(id);
  }
}
